import * as yup from "yup";


export const dataKeysAndRepr = [
  { objKey: "requestId", repr: "Request Id" },
  { objKey: "customerName", repr: "Requested By" },
  { objKey: "initiatorRole", repr: "Role" },
  { objKey: "customerName", repr: "Requested For" },
  { objKey: "requestType", repr: "Action TYPE" },
  { objKey: "status", repr: "STATUS" },
  { objKey: "dateCreated", repr: "DATE CREATED" },
  { objKey: "action", repr: "ACTION" },
];

export const columns =[
  {
    field: "requestId",
    headerName: "Request Id",
    width: 100,
    editable: false,
  },
  {
    field: "customerName",
    headerName: "Requested For",
    width: 100,
    editable: false,
  },
  {
    field: "initiatorRole",
    headerName: "Role",
    width: 100,
    editable: false,
  },
  {
    field: "requestType",
    headerName: "Request Type",
    width: 100,
    editable: false,
  }
];

export const requestLogsSummaryCard = [
  {
    title: "TOTAL REQUEST",
    objKeyRepr: "totalRequests",
  },
  {
    title: "TOTAL APPROVED",
    objKeyRepr: "totalApproved",
  },
  {
    title: "TOTAL INITIATED",
    objKeyRepr: "totalInitiated",
  },
  {
    title: "TOTAL REJECTED",
    objKeyRepr: "rejected",
  },
  {
    title: "TOTAL FAILED",
    objKeyRepr: "totalFailed",
  },
];
